import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

export interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string
    fullWidth?: boolean
    invertValue?: boolean
    onClick?: () => void
}

const Container = styled.label`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`

const SwitchContainer = styled.div<{ checked: boolean }>`
    width: 36px;
    height: 20px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    position: relative;
    box-sizing: border-box;
    padding: 1px;
    cursor: pointer;
    background-color: ${({ checked }) =>
        checked ? 'var(--text-primary, #0DC3CA)' : 'var(--text-secondary, #9EE3E6)'};
    transition: 0.25s box-shadow ease-in-out, 0.25s background-color ease-in-out;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    top: -2px;
    left: -2px;
    opacity: 0;
    margin: 0;
    cursor: pointer;
`

const Circle = styled.div<{ checked: boolean }>`
    width: 14px;
    height: 14px;
    border-radius: 50%;
    transform: translate3d(${({ checked }) => (checked ? 16 : 2)}px, 0, 0);
    transition: 0.25s transform ease-in-out;
    box-shadow: ${({ checked }) => (checked ? '0px 4px 5px -1px rgba(0, 0, 0, 0.08)' : 0)};
    border: ${({ checked }) =>
        checked ? '0.75px solid rgba(255, 255, 255, 0.5)' : '0.75px solid #ffffff'};
    background: ${({ checked }) =>
        checked
            ? 'linear-gradient(123.85deg, rgba(255, 255, 255, 0.85) 16.92%, rgba(255, 255, 255, 0.35) 85.33%)'
            : 'linear-gradient(123.85deg, #ffffff 16.92%, rgba(255, 255, 255, 0.5) 85.33%)'};
`

export const Switch = React.forwardRef<HTMLLabelElement, SwitchProps>(
    ({ label, checked = false, type, fullWidth = false, disabled, ...props }, ref) => {
        return (
            <Container ref={ref} style={{ pointerEvents: disabled ? 'none' : 'initial' }}>
                <SwitchContainer checked={checked} style={{ opacity: disabled ? 0.5 : 1 }}>
                    <HiddenCheckbox checked={checked} disabled={disabled} readOnly {...props} />
                    <Circle checked={checked} />
                </SwitchContainer>
            </Container>
        )
    }
)
